module.exports = __webpack_public_path__ + "static/media/09 - Crash.248e0aa4.wav";